import { Filial } from "app/components/movimentacao-estoque/MovimentacaoEstoque";
import { ILotes } from "app/types/ILotes";
import globalMU from "globalMU";
import React, { memo, useCallback, useMemo } from "react";
import { Paginacao } from "../paginacao/Paginacao";

const estiloLotesValidade = require("./lotesValidade.module.scss").default;

export type LotesValidadeProps = {
  produto: string;
  descricao: string;
  dados: ILotes;
  filais: Filial[];
  permiteVisualizarValidade: boolean;
  exibeLocalFisicoConsultaProdutos: boolean;
  onPesquisarPorFilial: (numeroPagina: number, filial: string) => void;
  onPesquisarPaginado: (numeroPagina: number) => void
};

export const LotesValidade = memo((props: LotesValidadeProps) => {
  const onFilialChange = useCallback((e: React.ChangeEvent<HTMLSelectElement>) => {
    props.onPesquisarPorFilial(null, e.target.value)
  }, [props.onPesquisarPorFilial])

  const detalheProdutoSelecionado = useMemo(() => (
    <div className={estiloLotesValidade.form}>
      <label>Produto</label>
      <div>{props.produto}</div>
      <label>Descrição</label>
      <div>{props.descricao}</div>
      <label>Filial</label>
      <select className={estiloLotesValidade.select} name="TipoFrete"
        id="LotesValidade_SelectFilial"
        onChange={onFilialChange}>
        <option value={""}>Todas</option>
        {props.filais?.map((filial) => (
          <option key={filial.Codigo} value={filial.Codigo}>
            {filial.Descricao}
          </option>
        ))}
      </select>
    </div>
  ), [props.produto, props.descricao, props.filais, onFilialChange])

  const paginacao = useMemo(() => props.dados?.Lotes?.PageCount > 1 && (
    <Paginacao
      paginaAtual={props.dados?.Lotes?.ActualPage}
      totalPaginas={props.dados?.Lotes?.PageCount}
      id="LotesValidade_Paginacao"
      onAlterarListaSelecionada={props.onPesquisarPaginado}
    />
  ), [props.dados?.Lotes?.PageCount, props.dados?.Lotes?.ActualPage, props.onPesquisarPaginado])

  const tabelaLoteValidade = useMemo(() => {
    const tableHead = (
      <thead id="LotesValidade_TableHead">
        <tr>
          <th className={estiloLotesValidade.tableCellHeader}>Filial</th>
          {props.exibeLocalFisicoConsultaProdutos &&
            <th className={estiloLotesValidade.tableCellHeader}>Local Físico</th>
          }
          <th className={estiloLotesValidade.tableCellHeader}>Lote</th>
          <th className={estiloLotesValidade.tableCellHeader}>Tonalidade</th>
          <th className={estiloLotesValidade.tableCellHeader}>Bitola</th>

          <th className={estiloLotesValidade.tableCellHeader}>Situação</th>
          {props.permiteVisualizarValidade &&
            <th className={estiloLotesValidade.tableCellHeader}>Validade</th>
          }
          <th className={`_text-right ${estiloLotesValidade.tableCellHeader}`}>Quantidade</th>
          <th className={`_text-right ${estiloLotesValidade.tableCellHeader}`}>Reservado</th>
          <th className={`_text-right ${estiloLotesValidade.tableCellHeader}`}>Bloqueado</th>
          <th className={`_text-right ${estiloLotesValidade.tableCellHeader}`}>Disponível</th>
        </tr>
      </thead>
    )

    const tableBody = (
      <tbody id="LotesValidade_TableBody">
        {props.dados?.Lotes?.Entities?.map((dado, index) => (
          <tr key={`${dado?.CodigoFilial}_${dado?.Lote}`}
            id={`LotesValidade_TableBody_Row_${index}`}
          >
            <td className={estiloLotesValidade.tableCellBody}
              id={`LotesValidade_TableBody_Row_${index}_CodigoFilial`}
            >{dado?.CodigoFilial}</td>
            {props.exibeLocalFisicoConsultaProdutos &&
              <td className={estiloLotesValidade.tableCellBody}
                id={`LotesValidade_TableBody_Row_${index}_LocalFisico`}
              >{dado?.LocalFisico}</td>
            }
            <td className={estiloLotesValidade.tableCellBody}
              id={`LotesValidade_TableBody_Row_${index}_Lote`}
            >{dado?.Lote}</td>
            <td className={estiloLotesValidade.tableCellBody}
              id={`LotesValidade_TableBody_Row_${index}_NomeTonalidade`}
            >{dado?.NomeTonalidade}</td>
            <td className={estiloLotesValidade.tableCellBody}
              id={`LotesValidade_TableBody_Row_${index}_NomeBitola`}
            >{dado?.NomeBitola}</td>
            <td className={estiloLotesValidade.tableCellBody}
              id={`LotesValidade_TableBody_Row_${index}_Situacao`}
            >{dado?.Situacao}</td>
            {props.permiteVisualizarValidade &&
              <td className={estiloLotesValidade.tableCellBody}
                id={`LotesValidade_TableBody_Row_${index}_Validade`}
                style={{ color: dado.LoteVencido ? "red" : "black" }}>{globalMU.formatDate(dado?.Validade)}</td>
            }
            <td className={`_text-right ${estiloLotesValidade.tableCellBody}`}
              id={`LotesValidade_TableBody_Row_${index}_QuantidadeSaidaLote`}
            >{globalMU.formatarValorNumerico(dado?.QuantidadeSaidaLote, 3)}</td>
            <td className={`_text-right ${estiloLotesValidade.tableCellBody}`}
              id={`LotesValidade_TableBody_Row_${index}_QuantidadeReservaLote`}
            >{globalMU.formatarValorNumerico(dado?.QuantidadeReservaLote, 3)}</td>
            <td className={`_text-right ${estiloLotesValidade.tableCellBody}`}
              id={`LotesValidade_TableBody_Row_${index}_QuantidadeBloqueadoVenda`}
            >{globalMU.formatarValorNumerico(dado?.QuantidadeBloqueadoVenda, 3)}</td>
            <td className={`_text-right ${estiloLotesValidade.tableCellBody}`}
              id={`LotesValidade_TableBody_Row_${index}_QuantidadeDisponivelVenda`}
            >{globalMU.formatarValorNumerico(dado?.QuantidadeDisponivelVenda, 3)}</td>
          </tr>
        ))}
      </tbody>
    )

    const rodape1 = (
      <tbody id="LotesValidade_TableFooter">
        <tr>
          <td colSpan={5 + Number(!!props.permiteVisualizarValidade) + Number(!!props.exibeLocalFisicoConsultaProdutos)} 
          className={`_text-right ${estiloLotesValidade.tableCellHeader}`}>Total</td>
          <td className={`_text-right ${estiloLotesValidade.tableCellHeader}`}
            id={`LotesValidade_TableFooter_QuantidadeSaidaLote`}
          >{globalMU.formatarValorNumerico(props.dados?.QuantidadeSaidaLotePagina, 3)}</td>
          <td className={`_text-right ${estiloLotesValidade.tableCellHeader}`}
            id={`LotesValidade_TableFooter_QuantidadeReservaLote`}
          >{globalMU.formatarValorNumerico(props.dados?.QuantidadeReservaLotePagina, 3)}</td>
          <td className={`_text-right ${estiloLotesValidade.tableCellHeader}`}
            id={`LotesValidade_TableFooter_QuantidadeBloqueadoVenda`}
          >{globalMU.formatarValorNumerico(props.dados?.QuantidadeBloqueadoVendaPagina, 3)}</td>
          <td className={`_text-right ${estiloLotesValidade.tableCellHeader}`}
            id={`LotesValidade_TableFooter_QuantidadeDisponivelVenda`}
          >{globalMU.formatarValorNumerico(props.dados?.QuantidadeDisponivelVendaPagina, 3)}</td>
        </tr>
      </tbody>
    )

    const rodape2 = (
      <tbody>
        <tr>
          <td colSpan={5 + Number(!!props.permiteVisualizarValidade) + Number(!!props.exibeLocalFisicoConsultaProdutos)} 
            className={`_text-right ${estiloLotesValidade.tableCellHeader}`}
          >Total</td>
          <td className={`_text-right ${estiloLotesValidade.tableCellHeader}`}
            id={`LotesValidade_TableFooter_Totais_QuantidadeSaidaLote`}
          >{props.dados === undefined ? "" : globalMU.formatarValorNumerico(props.dados?.Totais?.QuantidadeSaidaLote, 3)}</td>
          <td className={`_text-right ${estiloLotesValidade.tableCellHeader}`}
            id={`LotesValidade_TableFooter_Totais_QuantidadeReservaLote`}
          >{props.dados === undefined ? " " : globalMU.formatarValorNumerico(props.dados?.Totais?.QuantidadeReservaLote, 3)}</td>
          <td className={`_text-right ${estiloLotesValidade.tableCellHeader}`}
            id={`LotesValidade_TableFooter_Totais_QuantidadeBloqueadoVenda`}
          >{props.dados === undefined ? "" : globalMU.formatarValorNumerico(props.dados?.Totais?.QuantidadeBloqueadoVenda, 3)}</td>
          <td className={`_text-right ${estiloLotesValidade.tableCellHeader}`}
            id={`LotesValidade_TableFooter_Totais_QuantidadeDisponivelVenda`}
          >{props.dados === undefined ? "" : globalMU.formatarValorNumerico((props.dados?.Totais?.QuantidadeSaidaLote - props.dados?.Totais?.QuantidadeReservaLote - props.dados?.Totais?.QuantidadeBloqueadoVenda), 3)}</td>
        </tr>
      </tbody>
    )

    return (
      <div>
        <table className={`_w-full _border-collapse ${estiloLotesValidade.tabelaLoteValidade}`}
          id="LotesValidade_Table"
          style={{ marginRight: "5px" }}
        >
          {tableHead}
          {tableBody}
          {rodape1}
          {rodape2}
        </table>
      </div>
    )
  }, [props.dados, props.permiteVisualizarValidade, props.exibeLocalFisicoConsultaProdutos])

  return (
    <div style={{overflowX: "auto"}}>
      {detalheProdutoSelecionado}
      <br />
      {tabelaLoteValidade}
      {paginacao}
    </div>
  );
});
